import * as React from 'react';

import { SaveSuccessData } from '../../typings/common';
import { GridEditedEntity, GridEditedEntityType } from '../../typings/grid';
import { CampaignEditFrame } from '../CampaignEditFrame/CampaignEditFrame';
import { FrameEditPopup } from '../FrameEditPopup/FrameEditPopup';
import { GroupsEditFrame } from '../GroupsEditFrame/GroupsEditFrame';

export interface EditEntityControlProps {
    editedEntity?: GridEditedEntity;
    onEditPopupClose: () => void;
    onEditSuccess: () => void;
    onAddSuccess: (data: SaveSuccessData) => void;
}

export class EditEntityControl extends React.PureComponent<EditEntityControlProps> {
    render() {
        const { editedEntity, onEditPopupClose, onEditSuccess, onAddSuccess } = this.props;

        if (editedEntity === undefined) {
            return null;
        }

        switch (editedEntity.type) {
            case GridEditedEntityType.Campaign: {
                const { id, campaignType, login } = editedEntity;
                let onSaveSuccess: (data: SaveSuccessData) => void;
                let props;

                if (id !== undefined) {
                    onSaveSuccess = onEditSuccess;
                    props = { campaignId: id, login };
                } else {
                    onSaveSuccess = onAddSuccess;
                    props = { campaignType, login };
                }

                return (
                    <FrameEditPopup
                        entityType={GridEditedEntityType.Campaign}
                        onClose={onEditPopupClose}
                        onSaveSuccess={onSaveSuccess}
                    >
                        <CampaignEditFrame {...props} />
                    </FrameEditPopup>
                );
            }
            case GridEditedEntityType.Group: {
                const { groupIds, campaignId, campaignType, login, bannerIds, anchor } = editedEntity;
                let onSaveSuccess: (data: SaveSuccessData) => void;
                let props;

                if (groupIds !== undefined && groupIds.length !== 0) {
                    onSaveSuccess = onEditSuccess;
                    props = {
                        campaignId,
                        groupIds,
                        login,
                        campaignType,
                        bannerIds,
                        anchor
                    };
                } else {
                    onSaveSuccess = onAddSuccess;
                    props = { campaignId, campaignType, login, anchor };
                }

                return (
                    <FrameEditPopup
                        entityType={GridEditedEntityType.Group}
                        onClose={onEditPopupClose}
                        onSaveSuccess={onSaveSuccess}
                    >
                        <GroupsEditFrame {...props} />
                    </FrameEditPopup>
                );
            }
            default:
                throw `Неподдерживаемый тип`;
        }
    }
}
